import * as React from 'react'

interface Props {
    className?: string
    children: React.ReactNode
}
export default function Alert ({children, className = 'danger'}: Props){
        return (
            <div className={`alert alert-${className} alert-dismissable`} style={{whiteSpace: 'pre-line'}}>
                {children}
            </div>
        )
} 


// WEBPACK FOOTER //
// ./src/components/controls/standart/Alert.tsx